import { Grouping } from '@devexpress/dx-react-grid';
import { UpdateDiscrepancyListActionPayload } from './rootReducerTypes';
import { Discrepancy } from '../Interfaces';

// #region actions
export type DiscrepancyListActionTypes =
    UpdateDiscrepanciesAction
    | RequestErrorAction
    | FetchInitAction
    | SetCurrentPageAction
    | UpdateQueryAction
    | SetPageSizeAction
    | UpdatedDiscrepancyIsRequestedCloseCheckedAction
    | UpdatedDiscrepancyStatusAction
    | UpdateDiscrepancyTypeAction
    | UpdateSortByAction
    | UpdateSearcDiscrepanciesAction
    | ChangeGroupingAction
    | SetExpandedGroupsAction
    | EndLoadingAction
    | UpdateDiscrepancySelectedRowsAction

export const UPDATE_DISCREPANCIES = "UPDATE_DISCREPANCIES";
export interface UpdateDiscrepanciesAction {
    type: typeof UPDATE_DISCREPANCIES;
    updateDiscrepanciesActionPayload: UpdateDiscrepancyListActionPayload;
}

export const REQUEST_ERROR = "REQUEST_ERROR";
export interface RequestErrorAction {
    type: typeof REQUEST_ERROR;
}

export const FETCH_INIT = "FETCH_INIT";
export interface FetchInitAction {
    type: typeof FETCH_INIT;
}

export const END_LOADING = "END_LOADING";
export interface EndLoadingAction {
    type: typeof END_LOADING;
}

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export interface SetCurrentPageAction {
    type: typeof SET_CURRENT_PAGE;
    currentPage: number;
}
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export interface SetPageSizeAction {
    type: typeof SET_PAGE_SIZE;
    pageSize: number;
}
export const UPDATE_QUERY = "UPDATE_QUERY";
export interface UpdateQueryAction {
    type: typeof UPDATE_QUERY;
    lastQuery: string;
}

export const UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED = "UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED";
export interface UpdatedDiscrepancyIsRequestedCloseCheckedAction {
    type: typeof UPDATE_DISCREPANCY_ISREQUESTCLOSEDCHECKED;
    isRequestedClosedChecked: boolean;
}

export const UPDATE_DISCREPANCY_STATUS = "UPDATE_DISCREPANCY_STATUS";
export interface UpdatedDiscrepancyStatusAction {
    type: typeof UPDATE_DISCREPANCY_STATUS;
    discrepancyStatus: any;
}

export const UPDATE_DISCREPANCY_TYPE = "UPDATE_DISCREPANCY_TYPE";
export interface UpdateDiscrepancyTypeAction {
    type: typeof UPDATE_DISCREPANCY_TYPE;
    discrepancyType: any;
}

export const UPDATE_SORTBY = "UPDATE_SORTBY";
export interface UpdateSortByAction {
    type: typeof UPDATE_SORTBY;
    sortBy: string;
}

export const UPDATE_SEARCH_DISCREPANCIES = "UPDATE_SEARCH_DISCREPANCIES";
export interface UpdateSearcDiscrepanciesAction {
    type: typeof UPDATE_SEARCH_DISCREPANCIES;
    searchText: string;
}

export const CHANGE_GROUPING = "CHANGE_GROUPING";
export interface ChangeGroupingAction {
    type: typeof CHANGE_GROUPING,
    grouping: Grouping[]
}

export const SET_EXPANDED_GROUPS = "SET_EXPANDED_GROUPS"
export interface SetExpandedGroupsAction {
    type: typeof SET_EXPANDED_GROUPS,
    expandedGroups: string[]
}

export const SET_SELECTED_DISCREPANCY_ROWS = "SET_SELECTED_DISCREPANCY_ROWS";
export interface UpdateDiscrepancySelectedRowsAction {
    type: typeof SET_SELECTED_DISCREPANCY_ROWS;
    selectedRows: Array<Discrepancy>;
}